import axiosInstance from "../../../services/axiosInstance";

export const login = async (payload) => {
  try {
    return await axiosInstance.post("/User/login", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    const message= error.response?.data?.message;
    throw new Error(message); 
  }
};